import { render, staticRenderFns } from "./loginTab.vue?vue&type=template&id=5f27054a&scoped=true"
import script from "./loginTab.vue?vue&type=script&lang=js"
export * from "./loginTab.vue?vue&type=script&lang=js"
import style0 from "./loginTab.vue?vue&type=style&index=0&id=5f27054a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f27054a",
  null
  
)

export default component.exports